import client from './RestClient';
import _ from 'lodash';
import { AxiosInstance } from 'axios';

export interface ShopCategoryNode {
  id: string;
  label: string;
  value?: string;
  children?: ShopCategoryNode[];
  count?: number;
}
export interface CategoryWebService {
  getShopProductCategories(parentId?: string): Promise<ShopCategoryNode[]>;
}

function wrapNode(json: any): ShopCategoryNode {
  const childrenRaw = Array.isArray(json.options) ? json.options : [];
  const children = childrenRaw.map((child: any) => ({
    id: _.get(child, 'value', ''),
    value: _.get(child, 'value', ''),
    label: _.get(child, 'label', ''),
    count: _.get(child, 'count', 0),
  }));

  return {
    id: _.get(json, 'value', ''),
    value: _.get(json, 'value', ''),
    label: _.get(json, 'label', ''),
    children,
  };
}

export class RestfulCampaignWebService implements CategoryWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getShopProductCategories(
    webBrandNo: string,
  ): Promise<ShopCategoryNode[]> {
    const response = await this.restClient.get(
      `/dsp/brandKeywords/categories?webBrandNo=${webBrandNo}`,
    );
    return response.data.records.map(wrapNode);
  }
}
